import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { Transition, UIRouterModule } from '@uirouter/angular';
import { InvoiceSessionNumberContainerComponent } from '.';
import { processResolver } from '../../efaact-routing/process-resolver';
import { CategoriesService } from '../../shared';
import { SharedModule } from '../../shared/shared.module';
import * as Management from '../management';
import { InvoiceDateRangeRoute } from './invoice-date-range.route';
import { InvoiceRenumberingRoute } from './invoice-renumbering.route';
import { InvoiceSessionNumberComponent } from './invoice-session-number';

@NgModule({
    declarations: [
        InvoiceSessionNumberContainerComponent,
        InvoiceSessionNumberComponent
    ],
    imports: [
        CommonModule,
        SharedModule,
        UIRouterModule,
        UIRouterModule.forChild({
            states: [
                InvoiceRenumberingRoute,
                InvoiceDateRangeRoute
            ]
        }),
        EffectsModule.forFeature([
            Management.Invoice.InvoiceEffects,
            Management.ChargeNumber.InvoiceChargeNumberEffects,
            Management.SessionNumber.InvoiceSessionNumberEffects
        ]),
        StoreModule.forFeature(
            Management.Invoice.invoicesFeatureKey,
            Management.Invoice.reducer
        ),
        StoreModule.forFeature(
            Management.ChargeNumber.invoiceChargeNumbersFeatureKey,
            Management.ChargeNumber.reducer
        ),
        StoreModule.forFeature(
            Management.SessionNumber.invoiceSessionNumbersFeatureKey,
            Management.SessionNumber.reducer
        )
    ]
})
export class InvoiceRenumberingModule {}
